import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, Form, Table, Button, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { debounce } from 'lodash';
import Select from 'react-select';
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const BomPumpUpdate = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [finishedproductOptions, setfinishedproductOptions] = useState([]);
    const [finishedproductSearch, setfinishedproductSearch] = useState(encodeURIComponent(" "));
    const [selectedfinishedproduct, setSelectedfinishedproduct] = useState(null);
    const [productTableRaw, setproductTableRaw] = useState([]);
    const [selectedPumpRawSemiProduct, setSelectedPumpRawSemiProduct] = useState(null);
    const [PumpRawSemiProductSearch, setPumpRawSemiProductSearch] = useState("");
    const [PumpRawSemiProductOptions, setPumpRawSemiProductOptions] = useState([]);
    const [labourcharges, setlabourcharges] = useState(0);
    const [partno, setpartno] = useState('');
    const [jobnumber, setjobnumber] = useState('');


    const handleSearchChangePumpRawSemiProduct = debounce((inputValue) => {
        setPumpRawSemiProductSearch(inputValue);
    }, 500);

    const getPumpRawSemiProductProductData = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}product/page/ptype/0/10/desc/id/1/Raw Material, Semi Finished,Services/${PumpRawSemiProductSearch || encodeURIComponent(" ")}`,
                { headers: authHeader() }
            );
            const PumpRawSemiProducts = response.data.Index || response.data.data;
            setPumpRawSemiProductOptions(
                PumpRawSemiProducts.map((product) => ({
                    value: product.id,
                    label: `${product.description}- Part No.: ${product.partno} - MOC: ${product.moc} - Size: ${product.size}`,
                    uom: product.unitofmeasurement || '',
                    pumprequiredquantity: product.pumprequiredquantity || '',
                    rate: product.rate || '',
                    partno: product.partno || '',
                    moc: product.moc || '',
                    size: product.size || '',
                }))
            );
        } catch (error) {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to fetch product data.' });
        }
    };

    useEffect(() => {
        getPumpRawSemiProductProductData();
    }, [PumpRawSemiProductSearch]);

    const handlePumpRawSemiProductSelect = (selected) => {
        setSelectedPumpRawSemiProduct(selected);
        if (selected) {
            setproductTableRaw([
                ...productTableRaw,
                {
                    PumpRawSemiProduct: selected,
                    partname: '',
                    uom: selected.uom,
                    pumprequiredquantity: selected.pumprequiredquantity,
                    rate: selected.rate,
                    amount: (selected.pumprequiredquantity || 0) * (selected.rate || 0),
                    partno: selected.partno,
                    moc: selected.moc,
                    size: selected.size,
                    description: selected.label.split(' - ')[0],
                },
            ]);
        }
    };

    const handleRawSemiInputChanges = (index, field, value) => {
        const updatedRows = [...productTableRaw];
        updatedRows[index][field] = value;

        if (field === 'pumprequiredquantity' || field === 'rate') {
            const pumprequiredquantity = parseFloat(updatedRows[index].pumprequiredquantity) || 0;
            const rate = parseFloat(updatedRows[index].rate) || 0;
            updatedRows[index].amount = pumprequiredquantity * rate;
        }

        setproductTableRaw(updatedRows);
    };

    const handleRawSemiRemoveRow = (index) => {
        const updatedRows = productTableRaw.filter((_, rowIndex) => rowIndex !== index);
        setproductTableRaw(updatedRows);
    };

    const RawSemicalculateTotalCost = () => {
        return productTableRaw.reduce((total, row) => total + (row.amount || 0), 0);
    };

    const getFinishedProduct = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}product/page/ptype/0/10/desc/id/1/Finished/${finishedproductSearch.length > 0 ? finishedproductSearch : encodeURIComponent(" ")}`,
                { headers: authHeader() }
            );
            const finishedproducts = response.data.Index || response.data.data;
            setfinishedproductOptions(
                finishedproducts.map((finishedproduct) => ({
                    value: finishedproduct.id,
                    label: finishedproduct.description,
                    partno: finishedproduct.partno || '',
                    labourcharges: finishedproduct.labourcharges || 0,
                }))
            );
        } catch (error) {
            console.error('Error fetching finishedproduct data', error);
        }
    };

    const handleFinishedProductChange = (selected) => {
        setSelectedfinishedproduct(selected);
        setpartno(selected?.partno || '');
        setlabourcharges(parseFloat(selected?.labourcharges || 0));
    };

    const handleSearchChangefinishedproduct = debounce((inputValue) => {
        setfinishedproductSearch(inputValue);
    }, 500);

    useEffect(() => {
        getFinishedProduct();
    }, [finishedproductSearch]);

    const calculateLabourChargeAmount = () => {
        return (RawSemicalculateTotalCost() * labourcharges) / 100;
    };

    const calculateGrandTotal = () => {
        return RawSemicalculateTotalCost() + calculateLabourChargeAmount();
    };

    const fetchBomById = async () => {
        try {
            const response = await axios.get(`${BASE_URL}bom/${id}`, {
                headers: authHeader(),
            });
            const data = response.data;

            setSelectedfinishedproduct({
                value: data.finalfinishedproduct.id,
                label: data.finalfinishedproduct.description,
                partno: data.finalfinishedproduct.partno,
                labourcharges: data.labourcharges
            });


            setpartno(data.finalfinishedproduct.partno);
            setlabourcharges(parseFloat(data.labourcharges));
            setjobnumber(data.jobnumber);

            const rows = data.bomPumpPartsItemsRawSemiService.map(item => ({
                PumpRawSemiProduct: {
                    value: item.product.id,
                    label: item.description + ' - Part No.: ' + item.partno + ' - MOC: ' + item.moc + ' - Size: ' + item.size,
                    uom: item.uom,
                    rate: item.rate,
                    pumprequiredquantity: item.pumprequiredquantity,
                    partno: item.partno,
                    moc: item.moc,
                    size: item.size,
                },
                description: item.description,
                partname: item.partname,
                uom: item.uom,
                rate: item.rate,
                pumprequiredquantity: item.pumprequiredquantity,
                amount: item.amount,
                partno: item.partno,
                moc: item.moc,
                size: item.size,
            }));

            setproductTableRaw(rows);
        } catch (error) {
            console.error('Error loading BOM:', error);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to load BOM data.' });
        }
    };

    useEffect(() => {
        if (id) {
            fetchBomById();
        }
    }, [id]);

    const handleSubmit = async () => {
        if (RawSemicalculateTotalCost() === 0) {
            Swal.fire({ icon: 'error', title: 'Validation Error', text: 'Total cost cannot be zero.' });
            return;
        }

        const payload = {
            finalfinishedproduct: selectedfinishedproduct ? { id: selectedfinishedproduct.value } : null,
            bomPumpPartsItemsRawSemiService: productTableRaw.map(row => ({
                product: { id: row.PumpRawSemiProduct?.value },
                description: row.description,
                partname: row.partname,
                partno: row.partno,
                moc: row.moc,
                size: row.size,
                pumprequiredquantity: row.pumprequiredquantity,
                uom: row.uom,
                rate: row.rate,
                amount: row.amount,
            })),
            pumpbomrawmaterialtotalcost: RawSemicalculateTotalCost(),
            labourcharges: calculateLabourChargeAmount(),
            grandtotalpump: calculateGrandTotal(),
            bomtype: 'Pump',
            jobnumber,
        };

        try {
            const response = await axios.put(`${BASE_URL}bom/${id}`, payload, {
                headers: {
                    ...authHeader(),
                    'Content-Type': 'application/json',
                },
            });

            Swal.fire({ icon: 'success', title: 'Success', text: 'BOM updated successfully!' })
                .then(() => {
                    navigate(`/bomindex/1`);
                });

        } catch (error) {
            console.error('Update failed:', error);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to update the BOM.' });
        }
    };

    return (
        <div className="Container">
            <Card className="card">
                <Card.Header className="card-header">
                    <h6>BOM UPDATE</h6>
                    <Link to="/bomindex/1">
                        <button className="button-70">BACK</button>
                    </Link>
                </Card.Header>
                <Card.Body>
                    <Form>
                        <Row>
                            <Col md="6">
                                <Form.Group>
                                    <Form.Label>Product Name (Finished):</Form.Label>
                                    <Select
                                        options={finishedproductOptions}
                                        onChange={handleFinishedProductChange}
                                        onInputChange={handleSearchChangefinishedproduct}
                                        value={selectedfinishedproduct}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md="6">
                                <Form.Group>
                                    <Form.Label>Part Number</Form.Label>
                                    <Form.Control type="text" value={partno} readOnly />
                                </Form.Group>
                            </Col>
                            <Col md="6">
                                <Form.Group>
                                    <Form.Label>Job Number</Form.Label>
                                    <Form.Control type="text" value={jobnumber} readOnly />
                                </Form.Group>
                            </Col>
                        </Row>

                        <hr />
                        <Form.Group>
                            <Form.Label>Select Raw/Semi/Service Products :</Form.Label>
                            <Select
                                options={PumpRawSemiProductOptions}
                                onChange={handlePumpRawSemiProductSelect}
                                onInputChange={handleSearchChangePumpRawSemiProduct}
                                value={selectedPumpRawSemiProduct}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                            />
                        </Form.Group>

                        <br />
                        <div className="table-responsive">
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Part Name</th>
                                        <th>Part No.</th>
                                        <th>MOC</th>
                                        <th>Size</th>
                                        <th>quantity</th>
                                        <th>unit of measurement</th>
                                        <th>Rate</th>
                                        <th>Amount</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productTableRaw.map((row, index) => (
                                        <tr key={index}>
                                            <th>{index + 1}</th>
                                            <td>{row.PumpRawSemiProduct.label.split(' - ')[0]}</td>
                                            <td>{row.partno}</td>
                                            <td>{row.moc}</td>
                                            <td>{row.size}</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    value={row.pumprequiredquantity}
                                                    onChange={(e) => handleRawSemiInputChanges(index, 'pumprequiredquantity', e.target.value)}
                                                    min="0"
                                                />
                                            </td>
                                            <td>{row.uom}</td>
                                            <td>
                                                <Form.Control
                                                    className="uom"
                                                    type="number"
                                                    value={row.rate}
                                                    onChange={(e) => handleRawSemiInputChanges(index, 'rate', e.target.value)}
                                                    min="0"
                                                />
                                            </td>
                                            <td>{row.amount}</td>
                                            <td>
                                                <Button variant="danger" onClick={() => handleRawSemiRemoveRow(index)}>X</Button>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="7" className="text-end"><strong>Total Cost:</strong></td>
                                        <td colSpan="2"><strong>{RawSemicalculateTotalCost().toFixed(2)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7" className="text-end"><strong>Labour Charges (%)</strong></td>
                                        <td colSpan="2">
                                            <Form.Control
                                                type="number"
                                                value={labourcharges}
                                                onChange={(e) => setlabourcharges(parseFloat(e.target.value) || 0)}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7" className="text-end"><strong>Labour amount: ₹ </strong></td>
                                        <td colSpan="2">
                                            {calculateLabourChargeAmount().toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7" className="text-end"><strong>Grand Total:</strong></td>
                                        <td colSpan="2"><strong>{calculateGrandTotal().toFixed(2)}</strong></td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                        <Button variant="primary" onClick={handleSubmit}>Update</Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default BomPumpUpdate;
